// LocationService.js
// Service to fetch talukas and villages from the API
import API_CONFIG from '../../config/apiConfig';

const BASE_URL = `${API_CONFIG.BASE_URL}/locations`;

export async function fetchTalukas() {
  try {
    const response = await fetch(`${BASE_URL}/talukas`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to fetch talukas');
    return await response.json();
  } catch (error) {
    console.error('Error fetching talukas:', error);
    throw error;
  }
}

export async function fetchVillages(talukaId) {
  try {
    const response = await fetch(`${BASE_URL}/talukas/${talukaId}/villages`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to fetch villages');
    return await response.json();
  } catch (error) {
    console.error('Error fetching villages:', error);
    throw error;
  }
}
